export default __webpack_public_path__ + "static/media/img1.a317ca1c.jpg";